import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { installPhoneClickTracking } from "../lib/analytics";

/**
 * Tracks SPA route changes for Google Analytics 4 (G-ZVRRB91H5J) and Google Tag (GT-W6KDBW87).
 * Fires a page_view event on every URL change, since we disabled send_page_view in the gtag config.
 * Also installs a global delegated listener for phone-click conversions.
 */
export default function GoogleAnalytics() {
    const location = useLocation();

    useEffect(() => {
        const teardown = installPhoneClickTracking();
        return teardown;
    }, []);

    useEffect(() => {
        if (typeof window.gtag !== "function") return;
        const path = location.pathname + location.search;
        window.gtag("event", "page_view", {
            page_path: path,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [location.pathname, location.search]); // `path` is derived from these, no need to list separately

    return null;
}
